import { render, staticRenderFns } from "./core_image.vue?vue&type=template&id=7c870842&scoped=true"
import script from "./core_image.vue?vue&type=script&lang=js"
export * from "./core_image.vue?vue&type=script&lang=js"
import style1 from "./core_image.vue?vue&type=style&index=1&id=7c870842&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c870842",
  null
  
)

export default component.exports